<div class="panel-body " *ngIf="supplementalDispositions.length ===0">
	<div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
			<div class="panel-title">
				Supplemental Dispositions
			</div>
			<div class="panel-body ">
				No Supplemental Dispositions information available for this allegation.
			</div>
	</div>
</div>
<!-- <div class="panel-body " *ngIf="supplementalDispositions.length ===0">
  No Supplemental Dispositions information available for this allegation.
</div> -->
<div class="panel-body " *ngIf="supplementalDispositions.length !==0">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top"  *ngFor="let supplementalDisposition of supplementalDispositions; let al = index">
      <div class="panel-title" *ngFor="let parent of supplementalDisposition.getParents(); let al = index">
        Supplemental Dispositions - {{parent.getRelationship()}}
      </div>
     <div class="panel-body ">
        <div class="col-md-6 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="supplementalDisposition.getParents().length !==0">
            <div class="panel-title">
              Parent/Guardian/Custodian Assigned
            </div>
            <div class="panel-body" *ngFor="let parent of supplementalDisposition.getParents(); let al = index">
              {{parent.getPartyName() + ' (' + parent.getRelationship() + ')'}}
            </div>
        </div>
        <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
            <div class="panel panel-default" *ngIf="supplementalDisposition.getOtherAllegations().length !=0">
                <div class="panel-title">
                  Other Allegations Included On Order
                </div>
                <div class="panel-body" >
                    <div class="row table-responsive">
                        <table id="allegations-table" class="table table-condensed table-striped">
                            <thead>
                                <tr>
                                    <th id="V122c">
                                      <span class="field-code ">V122c json='allegations.pleadingType'</span>
                                      Pleading Type <br> 
                                      <span class="field-code ">V122c json='allegations.clockDate'</span>
                                      And Clock Date
                                    </th>
                                    <th id="V121c">
                                      <span class="field-code ">V121c json='allegations.allegation'</span>
                                        Allegation <br>
                                        <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                        Offense Date
                                      </th>
                                     </tr>
                            </thead>
                            <tbody  *ngFor="let otherAllegation of supplementalDisposition.getOtherAllegations()let i = index;">                            
                                 <tr >
                                  <td id="{{'juvenile-caseDetails-supplementalDisposition-' + i + '-pleadingType'}}">
                                    {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                                    {{otherAllegation.getOtherPleadingDate() | date:'MM/dd/yyyy'}} {{otherAllegation.getOtherPleadingTime()}}</td>
                                  <td id="{{'juvenile-caseDetails-supplementalDisposition-' + i + '-allegationDescription'}}">
                                    {{otherAllegation.getOtherAllegationDescription()}} <br>        
                                    {{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
                                </tr>    
                               </tbody>
                        </table>
                    </div>
                </div>
                </div>
            <div class="panel panel-default" *ngIf="supplementalDisposition.getFactsFound() !== ''">
            <div class="panel-title">
              Findings
            </div>
            <div class="panel-body">
              <B>The Court makes the following findings of fact in support of this Supplemental Order: </B>
              <ul style="list-style-type:disc">
                <li>{{supplementalDisposition.getFactsFound()}}</li>
              </ul>
            </div>
            </div>
            <div class="panel panel-default" *ngIf="supplementalDisposition.isOrderDetailsPresent() === true">
            <div class="panel-title">
              Order
            </div>
            <div class="panel-body">
              <B>The Court hereby ORDERS you, the person(s) named above:</B>
              <ul style="list-style-type:disc">
                <div *ngIf="supplementalDisposition.getAttendHearings() === 'Y'" >
                  <li>Attend Hearings [G.S. 7B-2700]</li>
                  <ul style="list-style-type:disc">
                    <span *ngIf="supplementalDisposition.getAttendHearingsText()!==''">
                    <li>{{supplementalDisposition.getAttendHearingsText()}}</li></span>
                  </ul>
                </div>
                <div *ngIf="supplementalDisposition.getProvideTransport() === 'Y'" >
                  <li>Provide Transportation [G.S. 7B-2703(a)]</li>
                  <span *ngIf="supplementalDisposition.getProvideTransportText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{supplementalDisposition.getProvideTransportText()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="supplementalDisposition.getHelpJuvenile() === 'Y'" >
                  <li>Help Juvenile Comply With Orders [G.S. 7B-2703(b)]</li>
                  <span *ngIf="supplementalDisposition.getHelpJuvenileText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{supplementalDisposition.getHelpJuvenileText()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="supplementalDisposition.getParentalClasses() === 'Y'" >
                  <li>Parental Responsibility Classes [G.S. 7B-2701]</li>
                  <span *ngIf="supplementalDisposition.getParentalClassesText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{supplementalDisposition.getParentalClassesText()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="supplementalDisposition.getPayTreatment() === 'Y'" >
                  <li>Pay Costs of Juvenile's Evaluation/Treatment [G.S. 7B-2502, -2702(a)]</li>
                  <span *ngIf="supplementalDisposition.getPayTreatmentText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{supplementalDisposition.getPayTreatmentText()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="supplementalDisposition.getParticipateTreat() === 'Y'" >
                  <li>Participate In Juvenile's Treatment [G.S. 7B-2702(b)]</li>
                  <span *ngIf="supplementalDisposition.getParticipateTreatText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{supplementalDisposition.getParticipateTreatText()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="supplementalDisposition.getUndergoEvaluation() === 'Y'" >
                  <li>Undergo Evaluation, Treatment, or Counseling [G.S. 7B-2702(c)]</li>
                  <ul style="list-style-type:disc">
                    <div *ngIf="supplementalDisposition.getComplyEvaluation() === 'Y'" >
                      <li>Comply with the plan of Evaluation, treatment, or counseling</li>
                    </div>                    
                    <div *ngIf="supplementalDisposition.getAssumeFlags() !== ''" >  
                        <li> {{supplementalDisposition.getAssumeFlags()}} </li>                      
                        <div *ngIf="supplementalDisposition.getAssumeResp() === 'Y'" >
                            <span *ngIf="supplementalDisposition.getAssumeText()!==''">
                            <ul style="list-style-type:disc">                            
                                  <li>{{supplementalDisposition.getAssumeText()}}</li>                            
                            </ul></span>
                          </div>
                    </div>                    
                    <div *ngIf="supplementalDisposition.getPayEvaluation() === 'Y'" >
                      <li>Pay for the Evaluation, treatment, or counseling to the following extent</li>
                      <span *ngIf="supplementalDisposition.getPayEvaluationText()!==''">
                      <ul style="list-style-type:disc">
                        <li>{{supplementalDisposition.getPayEvaluationText()}}</li>
                      </ul></span>
                    </div>
                  </ul>
                </div>
                <div *ngIf="supplementalDisposition.getPayExpenses() === 'Y'" >
                    <li>Payment of Support And/Or Other Expenses [G.S. 7B-2704]</li>
                    <ul style="list-style-type:disc">
                        <div *ngIf="supplementalDisposition.getPayNCCCOffice() === 'Y'" >
                          <li>Pay North Carolina Centralized Collections Office ${{supplementalDisposition.getPayNCCCOfficeAmount()}} per month</li>
                        </div>
                        <div *ngIf="supplementalDisposition.getPayClerk() === 'Y'" >
                            <li>Pay into the Office of the clerk of Superior Court</li>
                            <ul style="list-style-type:disc">
                              <li>${{supplementalDisposition.getPayProbationAmount()}} per month, for probation Supervision.</li>
                              <li>${{supplementalDisposition.getPayFacilityAmount()}} per month, for residential facility costs.</li>
                              <li>${{supplementalDisposition.getPayLegalFees()}} on or before {{supplementalDisposition.getLegalFeesDueDate()}}, for attorney fees.</li>
                            </ul>
                        </div>
                    </ul>
                  </div>
                  <div *ngIf="supplementalDisposition.getAssignInsurance() === 'Y'" >
                    <li>Assignment of Insurance [G.S. 7B-2704]<span  *ngIf="supplementalDisposition.getAssignInsuranceTo()!==''"> to {{supplementalDisposition.getAssignInsuranceTo()}} to cover medical costs.</span></li>
                  </div>
              </ul>
            </div>
            </div>   
        </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/supplemental-dispositions/supplemental-dispositions.component.html